@let dataValue = data();
@if (dataValue.toRemove === 'user') {
  <h2 mat-dialog-title>
    {{ 'PRODUCT.USERADMIN.USERLIST.REMOVEUSER.TITLE' | translate }}
  </h2>
  <mat-dialog-content>
    <p>
      {{ 'PRODUCT.USERADMIN.USERLIST.REMOVEUSER.TEXT1' | translate }}
      <b
        >{{ dataValue.userData['name'] }} ({{
          dataValue['userData']['email']
        }})</b
      >
      {{ 'PRODUCT.USERADMIN.USERLIST.REMOVEUSER.TEXT2' | translate }}
    </p>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-raised-button class="btn-app-save" mat-dialog-close>
      {{ 'PRODUCT.USERADMIN.USERLIST.REMOVEUSER.NO' | translate }}
    </button>
    <button
      mat-raised-button
      [mat-dialog-close]="true"
      cdkFocusInitial
      class="btn-app-cancel">
      {{ 'PRODUCT.USERADMIN.USERLIST.REMOVEUSER.YES' | translate }}
    </button>
  </mat-dialog-actions>
}

@if (dataValue.toRemove === 'address') {
  <h2 mat-dialog-title>
    {{ 'PRODUCT.USERADMIN.USERLIST.REMOVEUSER.TITLEADDRESS' | translate }}
  </h2>
  <mat-dialog-content>
    <p>
      {{ 'PRODUCT.USERADMIN.USERLIST.REMOVEUSER.TEXT3' | translate }}
      <b
        >{{ dataValue.address }} ({{
          'PRODUCT.USERADMIN.USERLIST.REMOVEUSER.' + dataValue.targetType
            | translate
        }})</b
      >
      {{ 'PRODUCT.USERADMIN.USERLIST.REMOVEUSER.TEXT2' | translate }}
    </p>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-raised-button class="btn-app-next" mat-dialog-close>
      {{ 'PRODUCT.USERADMIN.USERLIST.REMOVEUSER.NO' | translate }}
    </button>
    <button
      mat-raised-button
      [mat-dialog-close]="true"
      cdkFocusInitial
      class="btn-app-cancel">
      {{ 'PRODUCT.USERADMIN.USERLIST.REMOVEUSER.YES' | translate }}
    </button>
  </mat-dialog-actions>
}
